<script>
	import HowItWorks from "$components/HowItWorks.svelte";
</script>

<svelte:head>
	<title>How OS Studio Works | Platform Delivery Flow</title>
	<meta
		name="description"
		content="See the OS Studio delivery flow from requirement capture and architecture design to production release and continuous optimization."
	/>
	<meta
		property="og:title"
		content="How OS Studio Works | Platform Delivery Flow"
	/>
	<meta
		property="og:description"
		content="Structured 8-phase workflow from concept to secure, high-performance production launch."
	/>
	<meta property="og:type" content="website" />
</svelte:head>

<HowItWorks />
